export const ARTICLE_TABLE_CONTAINER_ID = "article-table"
export const ATTRIBUTE_TYPE_COMMERCIAL = "commercial"
export const ATTRIBUTE_TYPE_ESSENTIAL = "essential"
export const ATTRIBUTE_TYPE_TECHNICAL = "technical"
export const SEARCHABLE_CONTENT_COLUMN_ID = "searchableContent"
export const SYSTEMS_COLUMN_ID = "systems"
export const SYSTEMS_COLUMN_FILTER_FUNCTION = "systemsFilter"
export const ARTICLE_CODE_COLUMN_ID = "articleCode"

export const MAX_TRUNCATION_LINES = 4
//How do we end up with that 69 value.... 1.428571429 (line-height) * 12 (font-size) * 4 (the number of rows the POs want to have visible) = ±68.56
export const ARTICLE_REPLACEMENT_TEXT_BOX_HEIGHT = Math.ceil(1.428571429 * 12 * MAX_TRUNCATION_LINES)
export const PDP_REACT_PORTAL = "pdp-react-portal"

export const stateIndicator = {
  NEW: "NEW",
  PHASEOUT: "PHASEOUT",
}

export const ARTICLE_CODE_COLUMN_WIDTH = 251

export const attributeIDs = {
  SYSTEMS: "ATT_1854343",
  MAKE_TO_ORDER: "ATT_1844775",
  NET_PRICE: "netPrice",
  GROSS_PRICE: "grossPrice",
  ESSENTIAL: new Set(["ATT_11287", "ATT_11288", "ATT_11289", "ATT_245544"]),
  COMMERCIAL: new Set(["ATT_11256", "ATT_11257", "ATT_11258", "ATT_11259", "ATT_11260", "ATT_1844775"]),
}
export const specialSymbols = {
  ASTERISK: "*",
  DASH: "-",
}

export const highlightReferrer = {
  SEARCH: "search",
  ACCESSORIES: "accessories",
}

export const priceAttributesIds = {
  NET_PRICE: "netPrice",
  GROSS_PRICE: "grossPrice",
}
